<template>
  <div class="user">
    <v-container style="max-width: 800px">
      <v-row>
        <v-col cols="6" v-for="item in items" :key="item.title">
          <v-card class="coffee-option">
            <v-card-title>{{ item.title }}</v-card-title>
            <v-card-text></v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-divider style="margin: 1em" />
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>Fyll på vatten</v-card-title>
            <v-card-text>Vattenbehållaren är nästan tom</v-card-text>
            <v-card-actions>
              <v-btn text color="blue accent-4">Hur gör jag</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="!service.agreement">
        <v-col>
          <v-card>
            <v-card-title>Avkalkning</v-card-title>
            <v-card-text>Maskinen behöver snart avkalkas</v-card-text>
            
            <v-card-actions>
              <v-btn text color="blue accent-4" @click.stop="buyDialog = true">Vad behöver jag</v-btn>
              <v-btn text color="blue accent-4" @click.stop="stepDialog = true">Hur gör jag</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="buyDialog"
      max-width="400">
      <v-card>
        <v-card-title class="headline">Avkalkningsmedel</v-card-title>

        <v-card-text>
          <p>Vi rekommenderar vårt eget avkalkningsmedel</p>
          <v-btn text color="blue accent-4">Lägg i varukorg</v-btn>
          <v-btn text color="blue accent-4">Sök efter andra inköpsställen</v-btn>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue accent-4"
            text
            @click="buyDialog = false"
          >
            Stäng
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="stepDialog"
      max-width="400">
      <v-card>
        <v-card-title class="headline">Avkalkning</v-card-title>

        <v-card-text>
          <v-checkbox v-for="step in steps" v-model="step.state" :label="step.title" :key="step.title" :disabled="!(step.previous && step.previous.state)" />
          <v-btn text color="blue accent-4" :disabled="!steps[3].state">Starta avkalkning</v-btn>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue accent-4"
            text
            @click="stepDialog = false"
          >
            Stäng
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [{ title: "Kaffe" }, { title: "Espresso" }, { title: "Cappucino" }, { title: "Fler val..." }],
      service: { agreement: null },
      buyDialog: false,
      stepDialog: false,
      steps: [
        { state: true, title: "Starta maskinen" },
        { state: false, title: "Töm vattenbehållaren" },
        { state: false, title: "Fyll på avkalkningsmedel" },
        { state: false, title: "Fyll på vatten" },
        { state: false, title: "Starta avkalkning" },
      ]
    };
  },
  async created() {
      const response = await fetch('/api/service.json')
      this.service = await response.json();

      let previous = { state: true };
      for (const step of this.steps) {
        step.previous = previous;
        previous = step;
      }
  }
};
</script>

<style>
.theme--light.v-card.coffee-option:hover {
  background-color: lightgray;
  cursor: pointer;
}
</style>